export default "__VITE_ASSET__HIjBa_h$__"